import { GET, PATCH } from "../method.js";
import { ENDPOINTS } from "../ApiConstants.js"

export const addCardAPI = async (bin) => {
	const url = ENDPOINTS.ADD_CARD
	const data = { bin: bin };
	return PATCH(url, data);
};

export const userDetail = async () => {
	const url = ENDPOINTS.FULL_USER_DETAIL
	return GET(url);
}
export const userInfo = async () => {
	const url = ENDPOINTS.USER_DETAIL
	return GET(url);
}

export const offerCategoryList = async (id) => {
	const url = ENDPOINTS.OFFER_CATEGORY(id)
	return GET(url);
}

export const offerEventList = async (id) => {
	const url = ENDPOINTS.EVENT_LIST(id)
	return GET(url);
}

export const offerBrandList = async (id) => {
	const url = ENDPOINTS.BRAND_LIST(id)
	return GET(url);
}

export const offerCountryList = async (id) => {
	const url = ENDPOINTS.COUNTRY_LIST(id)
	return GET(url);
}

export const offerBrandCategoryList = async (id) => {
	const url = ENDPOINTS.BRAND_CATEGORY_LIST(id)
	return GET(url);
}
export const rewardListingFilterList = async (id) => {
	const url = ENDPOINTS.FILTER_LIST(id)
	return GET(url);
}

export const filterSearchResult = async (id) => {
	const url = ENDPOINTS.FILTER_SEARCH_RESULT(id)
	return GET(url);
}

export const filterPublicSearchResult = async (id) => {
	const url = ENDPOINTS.FILTER_PUBLIC_SEARCH_RESULT(id)
	return GET(url);
}

export const rewardListingHeadBannerAPI = async (id) => {
	const url = ENDPOINTS.BANNER_DATA(id)
	return GET(url);
}

export const superCategoryList = async (id) => {
	const url = ENDPOINTS.SUPERCATEGORY(id)
	return GET(url);
}

export const getSavingAmountAPI = async () => {
	const url = ENDPOINTS.SAVING_AMOUNT;
	return GET(url);
};

export const getHeroOffersAPI = async (id) => {
	const url = ENDPOINTS.HERO_OFFERS(id);
	return GET(url);
};

export const getBundleOffersAPI = async (id) => {
	const url = ENDPOINTS.BUNDLE_LIST(id);
	return GET(url);
};
